import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppCommonModule } from '@app/components/app.common.module';
import { BaseComponent } from '@app/components/base/base.component';
import { ModalService } from '@app/components/modal/modal.service';
import { environment } from '@env/environment.local';
import { FinancialSetupService } from '../financial-setup.service';
import { queryParamsFinancialSetup } from '../model.models';
import { StandardQuoteService } from '../../../standard-quote-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { AuthService } from "@app/common/auth.service";
import { RolesInternal } from "@app/models/roles.enum";
import { Permission } from "@app/models/permissions.enum";
import { TippyDirective } from "@ngneat/helipopper";
import { FinancialSetupCreationDto } from '../../../model/financial-setup.model';


@Component({
  selector: 'app-list-financial-setup',
  standalone: true,
  templateUrl: './list-financial-setup.component.html',
  styleUrl: './list-financial-setup.component.css',
  imports: [AppCommonModule, TippyDirective]
})
export class ListFinancialSetupComponent
  extends BaseComponent
  implements OnInit {

  @ViewChild('templateConfirmation') template!: TemplateRef<any>;
  isLoading: boolean = false;
  hasData: boolean = false;
  isMobile: boolean = false;
  @Input() financialSetupCreationDto: FinancialSetupCreationDto;

  data: any[] = [];
  pageSize: number = environment.pageSize;
  pageIndex: number = 1;
  total: number = 0;
  params: queryParamsFinancialSetup = {
    id: null,
    name: null,
    financialProduct: null,
    activeStartDate: null,
    active: true,
    isActiveStartDate: null,
    status: null,
    page: this.pageIndex,
    pageSize: this.pageSize,
    current: null,
  };

  title: string = 'Eliminar paquete financiero';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  reset: boolean;
  idSetup: string;
  selectedVersion: string = '';

  searchName: any = { placeholder: 'Buscar por nombre', value: '' };
  searchId: any = { placeholder: 'Buscar ID', value: '' };
  financialProducts: any[] = [
    { label: 'Credito directo', value: 'DIRECT_CREDIT' },
    { label: 'Arrendamiento financiero', value: 'FINANCIAL_LEASING' },
    { label: 'Arrendamiento puro', value: 'PURE_LEASING' },
    //{ label: 'CD Balloon', value: 'DIRECT_CREDIT_GLOBE' },
  ];

  FinancialSetupStatus: any[] = [
    { label: 'Aprobado', value: 'APPROVED' },
    //{ label: 'Descontinuado', value: 'DEPRECATED' },
    { label: 'Rechazado', value: 'REJECTED' },
    { label: 'En aprobación', value: 'IN_APPROVAL' },
    { label: 'Borrador', value: 'DRAFT' },
  ];

  activeList = [
    { label: 'Habilitado', value: true },
    { label: 'No Habilitado', value: false },
  ]

  FinancialSetupActiveCurrently: { label: string, value: boolean }[] = [
    { label: 'Vigente', value: true },
    { label: 'No Vigente', value: false },
  ]

  state: any[] = []
  isAdministrator: boolean = false;


  constructor(
    route: ActivatedRoute,
    private authService: AuthService,
    menu: MenusServices,
    private router: Router,
    notification: NotificationService,
    private service: FinancialSetupService,
    private modalService: ModalService,
    public serviceStandard: StandardQuoteService

  ) {
    super(route, menu, notification);
  }

  ngOnInit(): void {
    this.sendDataToMenu();
    this.getList()
    this.isAdministrator = this.isAdministratorRole()
  }

  getList() {
    this.isLoading = true;
    this.service.getFinancialSetup(this.params).subscribe({
      next: (response) => {
        this.data = response.data;
        this.total = response.totalElements;
        this.pageIndex = response.page - 1;
        this.hasData = this.data.length !== 0;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    })
  }

  search() {
    this.params.page = 1;
    this.getList();
  }

  resetFilters() {
    this.params = {
      id: 0,
      name: null,
      financialProduct: null,
      isActiveStartDate: null,
      active: null,
      status: null,
      activeStartDate: null,
      page: 1,
      pageSize: this.pageSize,
      current: null,
    };
    this.reset = !this.reset;
    this.getList();
  }

  duplicate(id: number) {
    this.isLoading = true;
    this.service.duplicateFinancialSetup(id).subscribe({
      next: (response) => {
        this.showNotificationSuccess(
          'El paquete financiero ha sido duplicado con éxito.'
        );
        this.isLoading = false;
        const financialSetup = response.data;
        this.router.navigate([`/quote/financial-setup/edit-setup/${financialSetup.id}`]);
      },
      error: (error) => {
        this.showNotificationError(
          'Ha ocurrido un error, el paquete financiero no se pudo duplicar.'
        );
        this.isLoading = false;
      }
    })
  }

  view(id: number) {
    this.router.navigate([`financial-setup/read-only/${id}`]);
  }

  edit(id: number) {
    this.router.navigate([`/quote/financial-setup/edit-setup/${id}`]);
  }

  openModalConfirmation(item: any) {
    this.idSetup = item.id;
    this.subtitle = `¿Confirma la eliminación del paquete financiero "${item.financialSetupName}"?`;
    this.modalService.component = this.template;
    this.modalService.openModal();
  }

  closeModal() {
    this.modalService.closeModal();
  }

  deleteSetup() {
    this.isLoading = true;
    this.service.deleteSetup(this.idSetup).subscribe({
      next: (response) => {
        this.showNotificationSuccess(
          'El paquete financiero ha sido eliminado con éxito.'
        );
        this.isLoading = false;
        this.modalService.closeModal();
        this.getList();
      },
      error: (error) => {
        this.showNotificationError(
          'Ha ocurrido un error, el paquete financiero no se pudo eliminar.'
        );
        this.isLoading = false;
      }
    })
  }

  filter(value: any, typeField: string) {
    switch (typeField) {
      case 'status':
        this.params.status = value == '' ? null : value;
        break;
      case 'name':
        this.params.name = value == '' ? null : value;
        break;
      case 'financialProduct':
        this.params.financialProduct = value == '' ? null : value;
        break;
      case 'active':
        this.params.active = value;
        break;
      case 'current':
        this.params.current = value;
        break;
      case 'activeStartDate':
        this.params.activeStartDate = new Date();
        break;
    }
  }

  handlePage(e: any) {
    this.params.page = e.pageIndex + 1;
    this.params.pageSize = e.pageSize;
    this.getList();
  }

  showStatus(item: any) {
    if (item.status == null) return "";
    return this.FinancialSetupStatus.find((i) => i.value == item.status)?.label;
  }

  showStatusLowerCase(item: any) {
    if (item.status == null) return "";
    return this.FinancialSetupStatus.find((i) => i.value == item.status)?.label.toLowerCase();
  }

  isAdministratorRole() {
    return this.authService
      .checkRoleFromParentMenu(
        Permission.financialSetup,
        RolesInternal.administrator);
  }

  show(index: number, status?: boolean) {
    if (index < this.data.length - 1) {
      const current = this.data[index];
      const previous = this.data[index - 1];
      if (index != 0) {
        if (current.financialSetupName.trim() === previous.financialSetupName.trim()) {
          if((current.status == 'APPROVED' && previous.status == 'REJECTED') || (previous.status == 'APPROVED' && current.status == 'REJECTED') ){
            return true;
          }
          return false;
        } else {
          return true;
        }
      }
    }
    return true
  }



  changeCss(index: number) {
    if (index < this.data.length - 1) {
      return this.data[index].financialSetupName.trim() === this.data[index + 1].financialSetupName.trim()
    }
    return false
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'DRAFT':
        return 'tag borrador';
      case 'IN_APPROVAL':
        return 'tag enAprobacion';
      case 'APPROVED':
        return 'tag aprobado';
      case 'REJECTED':
        return 'tag rechazado';
      case 'DEPRECATED':
        return 'tag descontinuado';
      default:
        return 'tag';
    }
  }
}

